import useMutation from '../../../ReactQuery/useMutation';
import { post } from '../../../redux/api';
import type { LicenseDisputeRequest, LicenseDisputeResponse } from '../../../../shared/issuesV2';

type CreateLicenseDisputeVariables = LicenseDisputeRequest & {
  issueId: number;
};

function createLicenseDispute({ issueId, ...body }: CreateLicenseDisputeVariables) {
  return post<LicenseDisputeRequest, LicenseDisputeResponse>(`/api/v2/issues/${issueId}/disputes`, body);
}

export function useCreateLicenseDispute() {
  return useMutation({
    mutationFn: createLicenseDispute,
  });
}
